/* SEASON: THANKSGIVING effects (light): a few falling leaves, countdown to Thanksgiving Day, side rails. Sale ends Nov 30, 11:59 PM Pacific. */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function turkeyDay(y){var d=new Date(y,10,1),off=(4-d.getDay()+7)%7;return new Date(y,10,1+off+21,23,59,59)}
  function label(){
    var n=new Date(),end=turkeyDay(n.getFullYear());
    if(n>end)return null;
    var t=new Date(end.getFullYear(),end.getMonth(),end.getDate());
    if(n.getFullYear()===end.getFullYear()&&n.getMonth()===end.getMonth()&&n.getDate()===end.getDate())return 'Happy Thanksgiving';
    var d=Math.ceil((t-n)/864e5);return 'Thanksgiving in '+d+' day'+(d===1?'':'s');
  }
  function count(){
    var t=label();
    document.querySelectorAll('[data-halloween-count]').forEach(function(el){if(t)el.textContent=t;else el.style.display='none'});
    var e=Date.UTC(new Date().getFullYear(),11,1,7,59,59)-Date.now();
    document.querySelectorAll('[data-halloween-clock]').forEach(function(el){
      if(e<=0){el.style.display='none';return}
      var d=Math.floor(e/864e5),h=Math.floor(e%864e5/36e5),m=Math.floor(e%36e5/6e4);
      el.textContent='Ends in '+d+'d '+h+'h '+m+'m';
    });
  }
  function rails(){
    var a=document.createElement('div');a.className='e-rail e-rail--l';a.textContent='GRIM EMPIRE  •  INSTANT DELIVERY  •  24/7 SUPPORT';
    var b=document.createElement('div');b.className='e-rail e-rail--r';b.textContent='HAPPY THANKSGIVING  •  35% OFF  •  CODE THANKSGIVING35';
    document.body.appendChild(a);document.body.appendChild(b);
  }
  var COLORS=['#e8782a','#f2bd4e','#b5341c','#c98a2b','#8a4b1f'];
  var LEAF='<svg viewBox="0 0 40 40"><path fill="COLOR" d="M20 2c3 5 9 8 13 9-2 3-2 6 0 9-3 0-5 1-6 3 2 2 3 5 2 8-4-1-7-1-9 1v6h-2v-6c-2-2-5-2-9-1-1-3 0-6 2-8-1-2-3-3-6-3 2-3 2-6 0-9 4-1 10-4 13-9z"/></svg>';
  var live=0;
  function leaf(){
    if(reduce||document.hidden||live>=5)return;
    var l=document.createElement('div');l.className='e-leaf';
    l.innerHTML=LEAF.replace('COLOR',COLORS[Math.floor(Math.random()*COLORS.length)]);
    l.style.setProperty('--x',(Math.random()*95)+'vw');
    l.style.setProperty('--w',(14+Math.random()*16).toFixed(0)+'px');
    l.style.setProperty('--d',(14+Math.random()*10).toFixed(1)+'s');
    l.style.setProperty('--dx',((Math.random()-.5)*160).toFixed(0)+'px');
    l.style.setProperty('--r',(180+Math.random()*360).toFixed(0)+'deg');
    document.body.appendChild(l);live++;
    setTimeout(function(){l.remove();live--},25000);
  }
  function init(){count();setInterval(count,30000);rails();setTimeout(leaf,3000);setInterval(leaf,7000)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();